
import { Component, Vue } from 'vue-property-decorator';
import { Pack } from "@/lib/Pack";
import { Guarantee } from "@/lib/Guarantee";
import { PackGuarantee } from "@/lib/PackGuarantee";
import { api } from "@/Api";
import { AxiosResponse } from "axios";
import EntityField from "@/components/EntityField.vue";
import router from '../router';


@Component({
    components: {
        EntityField,
    }
})
export default class OrderView extends Vue {
    public operator: string = '';
    public phone: string = '';
    public otp: string = '';
    public storageUrl = process.env.VUE_APP_CLOUD_STORAGE_URL;
    public consentLength = 0;
    public paymentTimeInterval: any = 0;
    public expiredPaymentTimeout: any = 0;
    public paymentToken = '';
    public paying = false;
    public fullStorageUrl = this.storageUrl + process.env.VUE_APP_CLOUD_STORAGE_ROOT_FOLDER + '/';
    public paymentState = {
        "code": "no",
        "message": ""
    };
    public countdownDate = new Date().getTime();
    public paymentUrl = null;
    public countDown = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        interval: 0 as any
    }
    public print() {
        window.print();
    }

    public isValidHttpUrl(string) {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

    public deliveryProofSet() {
        if (this.$store.state.order.contract.branch.slug === "auto") {
            return this.$store.state.order.additional.trim().length;
        }
        return true;
    }

    public consented() {
        return this.$store.state.order.consents.every((consent: boolean) => consent);
    }

    updateDeliveryInformation(data: any) {
        api.updateOrderDeliveryData(this.$store.state.order.id, data);
    }

    public pay() {

        const testToken = this.$route.query.test_token || "";
        if (!this.checkPaymentParams()) {
            this.$store.commit("throwError", "Merci de renseigner vos informations de paiement pour pouvoir souscrire");
            return;
        }
        if (!this.consented()) {
            this.$store.commit("throwError", "Merci d'acccepter les conditions générales ainsi que les conditions particulières du contrat");
            return;
        }
        if (!this.deliveryProofSet()) {
            this.$store.commit("throwError", "Merci de renseigner le numeros de chassis du véhicule dans le champs correspondant");
            return;
        }
        if (this.paying) {
            return;
        }

        this.paying = true;
        const params = {
            platformParameters: {
                operator: this.operator,
                platform: 'bizao',
                return_url: window.location.href,
                cancel_url: window.location.href
            },
            targetAccount: this.$store.state.order.userAccount.id,
            amount: this.$route.query.test_token === "49ae3cc8-f706-44f5-a573-27a1c1763030" ? 100 : this.$store.state.order.amount - 100,
            followUp: this.$store.state.order.avenantAccount.id

        };


        if (this.operator === 'CashOnDelivery' || this.operator === 'CheckOnDelivery') {
            api.sendDeliveryMail(this.$store.state.order.contract.uuid, this.operator === 'CashOnDelivery' ? 'cash' : 'check')
                .then((response: AxiosResponse) => {
                    const data = response.data;
                    if (data.status === 'failure') {
                        this.$store.commit('throwError', data.message);
                    } else {
                        this.$router.push({
                            name: 'home',
                            query: { thank: this.$store.state.order.contract.customer.details.nom }
                        })
                    }
                })
                .catch((reason) => {
                    this.paying = false;
                })
                ;

        } else {
            if (params.platformParameters.operator === 'wave') {
                params.platformParameters.platform = 'wave'
            }
            // console.log(params);
            // return;
            if (this.operator === 'card') {
                params.platformParameters.platform = 'bizao-credit-card';
            }
            clearTimeout(this.expiredPaymentTimeout);
            clearInterval(this.countDown.interval);
            this.startCountDown();
            this.expiredPaymentTimeout = setTimeout(() => {
                this.$store.commit('throwError', "Votre paiement a expiré, merci de reessayer, ou utilisez le tchat ci-dessous pour nous contacter");
                this.failPayment();
            }, 600000);
            api.pay(params, testToken).then((response: AxiosResponse) => {

                const data = response.data;
                console.log(data)
                if (data.status === 'failure') {
                    this.$store.commit('throwError', data.message);
                    this.failPayment();
                } else {
                    if (params.platformParameters.operator === 'bizao' || params.platformParameters.platform === 'bizao-credit-card') {
                        if (data.transaction.hasOwnProperty('extraInfo') && data.transaction.extraInfo.hasOwnProperty('payment_url')) {
                            window.location.assign(data.transaction.extraInfo.payment_url);
                            // console.log(data.transaction.extraInfo.payment_url);
                        } else {
                            this.$store.commit('throwError', 'No payment Url');
                        }
                    }
                    console.log(params.platformParameters.operator)
                    if(params.platformParameters.operator === 'wave'){
                        // console.log('is wave')
                        const url = data.transaction.data.wave_launch_url
                        window.location.href = url;
                        return
                    }

                    this.$store.commit('showMessage', 'Votre paiement est en cours de traitement. Vous allez recevoir le status par sms d\'ici peu');
                    this.paymentToken = data.transaction.paymentToken;

                    this.paymentTimeInterval = setInterval(() => {
                        this.paymentStatus();
                    }, 5000);
                    this.decideFromPaymentData(data.transaction);
                }
            })
        }
    }

    payWithWave(){

    }

    paymentStatus() {
        api.paymentStatus(this.paymentToken).then((response: AxiosResponse) => {
            this.decideFromPaymentData(response.data.transaction);
        });
    }

    startCountDown() {
        this.countdownDate = new Date(new Date().getTime() + (10 * 60000)).getTime();
        this.countDown.interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = this.countdownDate - now;
            this.countDown.days = Math.floor(distance / (1000 * 60 * 60 * 24));
            this.countDown.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.countDown.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            this.countDown.seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (distance < 0) {
                this.$store.commit('throwError', "Votre paiement a expiré, merci de reessayer, ou utilisez le tchat ci-dessous pour nous contacter");
                this.failPayment();
                clearInterval(this.countDown.interval);
            }
        }, 2000);

    }

    decideFromPaymentData(transaction: any) {
        const status = transaction.status;
        let message;
        let error = false;
        switch (status) {
            case "created":
                message = 'Initialization du paiement';
                break;
            case "pending":
                message = "Paiement en cours de traitement par l'opérateur";
                if (transaction.hasOwnProperty('extraInfo') && transaction.extraInfo.hasOwnProperty('payment_url')) {
                    this.paymentUrl = transaction.extraInfo.payment_url;
                    // window.open(transaction.extraInfo.payment_url, 'Paiement', 'width=600,height=600');
                }
                break;
            case "platform_refused":
                message = transaction.failureMessage || "Paiement refusé par l'opérateur";
                error = true;
                this.failPayment();
                break;
            case "failed":
                message = transaction.failureMessage || "echec de la transaction";
                error = true;
                this.failPayment();
                break;
            case "platform_validated":
                message = "Nous avons reçu le paiement avec succes - patientez encore un peu...";
                break;
            case "updated_target":
                message = "Nous avons reçu le paiement avec succes - nous vous recontacterons dans l'heure qui suit, vous pouvez fermer cette page";
                this.$router.push({
                    name: 'home',
                    query: { thank: this.$store.state.order.contract.customer.details.nom }
                });
                break;
            case "updated_follow_up":
                this.checkContractPaid();
                message = "Nous avons reçu le paiement avec succes - nous vous recontacterons dans l'heure qui suit, vous pouvez fermer cette page";
                break;
        }
        this.paymentState.message = message;
        this.paymentState.code = status;
        this.$store.commit(error ? 'throwError' : 'showMessage', message);
    }

    failPayment() {
        clearInterval(this.paymentTimeInterval);
        clearTimeout(this.expiredPaymentTimeout);
        this.paying = false;

        this.resetCountdown();
    }

    resetCountdown() {
        this.countDown.minutes = 0;
        this.countDown.seconds = 0;
        clearInterval(this.countDown.interval);
    }

    checkContractPaid() {
        clearInterval(this.paymentTimeInterval);

        api.getAccountBalance(this.$store.state.order.avenantAccount.id).then((response: AxiosResponse) => {
            this.resetCountdown();
            if (response.data.hasOwnProperty('account')) {
                const account = response.data.account;
                /* if (account.balance < 0) {
                     this.$store.commit('throwError', "Le montant envoyé est inférieur au montant réquis. Merci de contacter nos services pour en savoir plus");
                 } else { */
                this.$router.push({
                    name: 'home',
                    query: { thank: this.$store.state.order.contract.customer.details.nom }
                });
                //   }
                this.paying = false;
            }

        });
    }

    getUrlParameter(name: string) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };


    mounted() {
        const print = this.getUrlParameter('print');
        if (print) {
            setTimeout(function () {
                window.print();
            }, 2000);
        }
        this.consentLength = this.$store.state.order.consents.length + 1 - 0;
        if (!this.$store.state.towns.length) {
            this.$store.dispatch('loadTowns');
        }
        if (this.$route.query.hasOwnProperty('cancel') && this.$route.query.cancel === "true") {
            let query = Object.assign({}, this.$route.query);
            delete query.cancel;
            this.$router.replace({ query });
            this.$store.commit("throwError", "Paiement annulé");
        }

        if (this.$route.query.hasOwnProperty('token')) {
            this.paymentToken = this.$route.query.token;
            let query = Object.assign({}, this.$route.query);
            delete query.token;
            this.$router.replace({ query });

            this.paymentTimeInterval = setInterval(() => {
                this.paymentStatus();
            }, 5000);
        }

    }

    public changeOperator(operator: string) {
        this.operator = operator;
    }

    checkPaymentParams() {
        return true;
    }


    public displayDate(date: any) {
        return moment(date).format('DD/MM/YYYY');
    }

    public getFees(cost: number) {
        return 100;
        // return Math.ceil( (cost * 2 / 100 ) /+ 100);
        return Math.ceil(cost + 100);
    }

    public prettyMoney(amount: number) {
        const match = (Math.ceil(amount) + '').match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g);
        if (!match) {
            return amount;
        }
        return match.join(' ');
    }


    public displayDuration(duration: string) {
        if (duration === 'yearly') {
            return 'un an';
        } else if (duration === 'quarterly') {
            return '3 mois';
        } else {
            return 'un mois';
        }
    }

    public getPackGuarantee(pack: Pack, guarantee: Guarantee) {
        return pack.guarantees.find((packGuarantee: PackGuarantee) => {
            return guarantee.id === packGuarantee.guarantee.id;
        });
    }
}
